module.exports = __webpack_public_path__ + "static/media/Volbeat_gaussian2.8335f737.png";